<div class="glossary-root">
  @if (loading) {
    <div class="glossary-state-card glossary-state--loading">
      <div class="glossary-state-inner">
        <mat-spinner diameter="44"></mat-spinner>
        <h2 class="glossary-state-title">Loading glossary</h2>
        <p class="glossary-state-text">Fetching notes for all sections…</p>
      </div>
    </div>
  } @else if (error) {
    <div class="glossary-state-card glossary-state--error" role="alert">
      <div class="glossary-state-inner">
        <div class="glossary-state-icon-wrap glossary-state-icon-wrap--error">
          <mat-icon>error_outline</mat-icon>
        </div>
        <h2 class="glossary-state-title">Something went wrong</h2>
        <p class="glossary-state-text">{{ error }}</p>
      </div>
    </div>
  } @else if (sections.length === 0) {
    <div class="glossary-state-card glossary-state--empty">
      <div class="glossary-state-inner">
        <div class="glossary-state-icon-wrap">
          <mat-icon>menu_book</mat-icon>
        </div>
        <h2 class="glossary-state-title">No glossary entries yet</h2>
        <p class="glossary-state-text">
          When an administrator adds notes in <strong>Tab Notes</strong>, they will appear here grouped by section.
        </p>
      </div>
    </div>
  } @else {
    <mat-accordion class="glossary-accordion" [multi]="true">
      @for (item of sections; track item.note.id; let i = $index) {
        <mat-expansion-panel class="glossary-panel" [expanded]="i === 0">
          <mat-expansion-panel-header class="glossary-panel-header">
            <mat-panel-title class="glossary-panel-title">
              <!-- <span class="glossary-panel__order" aria-hidden="true">{{ i + 1 }}</span> -->
              <mat-icon class="glossary-panel__tab-icon" aria-hidden="true">tab</mat-icon>
              <span class="glossary-panel__name">{{ item.title }}</span>
            </mat-panel-title>
            <!-- <mat-panel-description class="glossary-panel-desc">
              {{ item.note.tab_name }}
            </mat-panel-description> -->
          </mat-expansion-panel-header>

          <div class="glossary-panel-body">
            <section
              class="glossary-panel__section"
              role="region"
              [attr.aria-label]="'Glossary notes for ' + item.title"
            >
              <div
                class="glossary-entry__content glossary-html"
                [innerHTML]="item.note.content"
              ></div>
            </section>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
